import type { ItemDto } from '@/api/eOrdersApi';

export type DocumentCategory = 'quotation' | 'purchaseOrder' | 'vehicleDeliveryForm' | 'proxyForRegistration';

const itemTypeNames: Record<DocumentCategory, readonly string[]> = {
  quotation: ['quotation', 'kalkulace'],
  purchaseOrder: ['purchase_order', 'objednavka'],
  vehicleDeliveryForm: ['vehicle_delivery_form', 'doklad'],
  proxyForRegistration: ['proxy_for_registration'],
}

export const isDocumentCategory = (item: ItemDto, category: DocumentCategory): boolean =>
  itemTypeNames[category].includes(item.itemtypeName?.toLowerCase() ?? '');

export const findDocument = (items: ItemDto[], category: DocumentCategory): ItemDto | null =>
  items.find(item => isDocumentCategory(item, category)) ?? null;

export const filterDocuments = (items: ItemDto[], category: DocumentCategory): ItemDto[] =>
  items.filter(item => isDocumentCategory(item, category));

const isKnownDocument = (item: ItemDto): boolean =>
  (Object.keys(itemTypeNames) as DocumentCategory[]).some(category => isDocumentCategory(item, category));

export const selectDocument = (items: ItemDto[], category: DocumentCategory): ItemDto | null => {
  const match = findDocument(items, category);

  if (match) return match;
  
  return items.find(item => !isKnownDocument(item)) ?? null;
}
